import * as React from 'react'
import { useCallback, useState } from 'react'
import { useGoogleApi } from 'react-gapi'

import Login from '../Auth/Login'
import Logout from '../Auth/Logout'

const SIGN_IN_CLASSES = 'no-margin'
const LOGIN_SECTION_CLASSES = 'center-text'

export type GoogleAuthProps = {
  requestedScopes: Array<string>
  authContainerStyle: string
  logoutButtonStyle: string
}

const GoogleAuth = (props: GoogleAuthProps): JSX.Element => {
  const { requestedScopes, authContainerStyle, logoutButtonStyle } = props
  const scopes: Array<string> = requestedScopes ?? [
    'https://www.googleapis.com/auth/classroom.courses.readonly',
    'https://www.googleapis.com/auth/classroom.rosters.readonly',
  ]
  const discoveryDocs: Array<string> = [
    'https://classroom.googleapis.com/$discovery/rest',
  ]
  const [showLogin, setShowLogin] = useState(true)

  // HACK: The library uses never type for these configs so we need to disable the `type 'string[] is not assignable to type never[]` error
  const gapi = useGoogleApi({
    // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
    // @ts-ignore
    scopes,
    // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
    // @ts-ignore
    discoveryDocs,
  })

  const auth = gapi?.auth2.getAuthInstance()

  const loginHandler = useCallback(() => {
    auth.signIn()
  }, [auth])

  const logoutHandler = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.location.reload()
    }
    setShowLogin(false)
    auth.signOut()
  }, [auth])

  return (
    <div className={authContainerStyle}>
      {!auth ? (
        <span>Loading...</span>
      ) : auth?.isSignedIn.get() ? (
        <>
          <p>
            Logged in as &quot;
            {auth.currentUser.get().getBasicProfile().getName()}&quot;{' '}
            <span>
              <Logout
                logoutHandler={logoutHandler}
                buttonStyle={logoutButtonStyle}
              />
            </span>
          </p>
        </>
      ) : (
        <div>
          {showLogin ? (
            <div className={LOGIN_SECTION_CLASSES}>
              <h1 className={SIGN_IN_CLASSES}>Sign In Please</h1>
              <Login loginHandler={loginHandler} />
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  )
}

GoogleAuth.defaultProps = {
  authContainerStyle: 'center-text',
  logoutButtonStyle: 'btn',
}

export default GoogleAuth
